import { render, staticRenderFns } from "./Chat-Bot.vue?vue&type=template&id=a485739c&scoped=true"
import script from "./Chat-Bot.vue?vue&type=script&lang=js"
export * from "./Chat-Bot.vue?vue&type=script&lang=js"
import style0 from "./Chat-Bot.vue?vue&type=style&index=0&id=a485739c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a485739c",
  null
  
)

export default component.exports